import createReducer, { objectActionHandler } from '../../../util/create_reducer';

import {
  PROFILE_LOAD_PROFILE,
  PROFILE_LOAD_PROFILE_SECTION,
  PROFILE_UPDATE_PROFILE,
  PROFILE_SAVE_PROFILE,
  PROFILE_SAVE_PROFILE_SECTION,
  PROFILE_SAVE_PROFILE_SECTION_VALUE,
  PROFILE_SAVE_EDUCATION_HISTORY,
  PROFILE_SET_OPTIONS,
  PROFILE_SET_ERRORS,
  PROFILE_SET_LOADING,
  PROFILE_LOAD_META,
  PROFILE_UPDATE_REQUIREMENT_ACTION,
  PROFILE_REMOVE_REQUIREMENT_FILE_ACTION,
  PROFILE_RETRIEVE_APPLICATIONS_ACTION,
  PROFILE_EDUCATION_SET_EXPANDED_ID_ACTION,
  PROFILE_SET_EDUCATION_HISTORY_ERRORS,
  PROFILE_HIGHLIGHT_ADD,
  PROFILE_HIGHLIGHT_REMOVE,
  PERSONAL_INFO_OVERLAY_TOGGLE,
} from '../actions/actionTypes';

export const defaultState = {
  loading: false,
  loadingSection: null,
  changedProfile: null,
  loadedProfile: null,
  educationHistory: [],
  educationHistoryErrors: {},
  options: {
    one_page: false,
  },
  errors: {},
  education_expanded_id: null,
  studentProfileDocuments: [],
  highlights: [],
  personalInfoOverlay: false,
};

const reducerSetLoading = (state, action) => ({
  loading: action.value,
});

const reducerUpdateProfile = (state, action) => ({
  changedProfile: {
    ...state.changedProfile,
    [action.value.propName]: action.value.value,
  },
});

const reducerLoadProfile = (state, action) => ({
  loadedProfile: {
    applyboard_username: state.loadedProfile.applyboard_username,
    ...action.value,
  },
  changedProfile: {
    applyboard_username: state.loadedProfile.applyboard_username,
    ...action.value,
  },
});

const reducerLoadMeta = (state, action) => ({
  meta: action.value,
});

const reducerSaveProfile = (state, action) => ({
  changedProfile: action.value,
});

const reducerSaveProfileSection = (state, action) => ({
  changedProfile: {
    ...state.changedProfile,
    [action.section]: action.value,
  },
});

const reducerProfileSectionValue = (state, action) => ({
  changedProfile: {
    ...state.changedProfile,
    [action.section]: {
      ...state.changedProfile[action.section],
      [action.key]: action.value,
    },
  },
});

const reducerSaveEducationHistory = (state, action) => ({
  educationHistory: action.value,
});

const reducerSetOptions = (state, action) => ({
  options: action.value,
});

const reducerSetErrors = (state, action) => ({
  errors: action.value || {},
});

const reducerLoadProfileSection = (state, action) => ({
  loadingSection: action.value,
});

const profileUpdateRequirement = (state, { value }) => ({
  changedProfile: {
    ...state.changedProfile,
    documents: state.changedProfile.documents.map(entry => (entry.id === value.id ? value : entry)),
  },
});

const profileRemoveRequirementFile = (state, { requirementId, fileId }) => {
  const requirement = state.changedProfile.documents.find(doc => doc.id === requirementId);

  if (!requirement) {
    console.warn('cant find requirement to remove file from');
    return {};
  }

  const files = requirement.files.filter(entry => entry.id !== fileId);

  const newRequirement = {
    ...requirement,
    files,
  };

  const documents = state.changedProfile.documents.map(entry =>
    entry.id === requirementId ? newRequirement : entry,
  );

  return {
    changedProfile: {
      ...state.changedProfile,
      documents,
    },
  };
};

const profileRetrieveApplicationsAction = (state, action) => ({
  applications: action.value,
});

const profileEducationSetExpandedId = (state, { value }) => ({
  education_expanded_id: value,
});

const setEducationHistoryErrors = (state, { schoolId, errors = [] }) => ({
  educationHistoryErrors: {
    ...state.educationHistoryErrors,
    [schoolId]: errors,
  },
});

const setProfileAddHighlight = (state, { value }) => {
  if (state.highlights.indexOf(value) >= 0) return state;

  return { highlights: state.highlights.concat(value) };
};

const setProfileRemoveHighlight = (state, { value }) => {
  if (state.highlights.indexOf(value) < 0) return state;

  return { highlights: state.highlights.filter(e => e !== value) };
};

const setPersonalInfoOverlayToggle = (state, { value }) => {
  return { personalInfoOverlay: value };
};

const reduceMap = {
  [PROFILE_EDUCATION_SET_EXPANDED_ID_ACTION]: profileEducationSetExpandedId,
  [PROFILE_HIGHLIGHT_ADD]: setProfileAddHighlight,
  [PROFILE_HIGHLIGHT_REMOVE]: setProfileRemoveHighlight,
  [PERSONAL_INFO_OVERLAY_TOGGLE]: setPersonalInfoOverlayToggle,
  [PROFILE_LOAD_META]: reducerLoadMeta,
  [PROFILE_LOAD_PROFILE]: reducerLoadProfile,
  [PROFILE_LOAD_PROFILE_SECTION]: reducerLoadProfileSection,
  [PROFILE_REMOVE_REQUIREMENT_FILE_ACTION]: profileRemoveRequirementFile,
  [PROFILE_RETRIEVE_APPLICATIONS_ACTION]: profileRetrieveApplicationsAction,
  [PROFILE_SAVE_EDUCATION_HISTORY]: reducerSaveEducationHistory,
  [PROFILE_SAVE_PROFILE]: reducerSaveProfile,
  [PROFILE_SAVE_PROFILE_SECTION]: reducerSaveProfileSection,
  [PROFILE_SAVE_PROFILE_SECTION_VALUE]: reducerProfileSectionValue,
  [PROFILE_SET_EDUCATION_HISTORY_ERRORS]: setEducationHistoryErrors,
  [PROFILE_SET_ERRORS]: reducerSetErrors,
  [PROFILE_SET_LOADING]: reducerSetLoading,
  [PROFILE_SET_OPTIONS]: reducerSetOptions,
  [PROFILE_UPDATE_PROFILE]: reducerUpdateProfile,
  [PROFILE_UPDATE_REQUIREMENT_ACTION]: profileUpdateRequirement,
};

const profileReducer = createReducer(defaultState, reduceMap, objectActionHandler);

export default profileReducer;
